// React & Router
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Axios for HTTP requests
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// React-Bootstrap
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';

// RSuite Components
import {
    VStack, HStack, Button, Text, Calendar, Modal, Input, InputNumber,
    Panel, DatePicker, SelectPicker, Loader, IconButton,
    CheckboxGroup, Checkbox, RadioGroup, Radio,
    Tooltip, Whisper
} from 'rsuite';

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class CounselingPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.innerWidth < 480,
            content: null,
            modal: null,
            loading: false,
            symbol: '',
            date: '',
            full_name: '',
            nickname: '',
            gender: '',
            age: '',
            year_level: '',
            consult_topic: '',
            next_field: '',
            consult_details: '',
            consult_method: '',
            method_detail: '',
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
        };

        this.handleResize = this.handleResize.bind(this);
    }

    async componentDidMount() {
        const logged = JSON.parse(localStorage.getItem('logged') || '{}');
        const token = logged?.user?.token;

        if (!token) {
            return (window.location.href = '/login');
        }

        const authHeader = {
            headers: { Authorization: `Bearer ${token}` }
        };

        await this.promisedSetState({ authHeader });

        try {
            await this.onRenderContent({ mode: 'read' });
        } catch (error) {
            if (error.response?.status === 401) {
                window.location.href = '/login';
            } else {
                // จัดการ error อื่น ๆ ตามปกติ
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        }

        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ isMobile: window.innerWidth < 480 });
    }

    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    /** ดึงข้อมูล consultation → แปลงเป็น events */
    fetchConsultationEvents = async (id, authHeader, emojiMap) => {
        const res = await axios.get(`${process.env.REACT_APP_API}/student-consultation/applicant/${id}`, authHeader);
        const data = res.data;
        const arr = Array.isArray(data) ? data : [data];

        return arr.map((item) => {
            const d = new Date(item.date);
            d.setDate(d.getDate() - 1);
            return {
                id: item.id,
                startDate: d.toISOString().split('T')[0],
                endDate: null,
                title: emojiMap[item.symbol] || item.symbol || '❓',
            };
        });
    };

    /** ดึง busy events 3 เดือน: เดือนก่อน หน้า และเดือนถัดไป ผ่าน API ใหม่ */
    fetchBusyEvents = async (authHeader, baseMonth, baseYear) => {
        // API ของคุณ `getByThreeMonths` จะคืน events ระหว่างเดือนก่อนหน้า → เดือนถัดไป
        const url = `${process.env.REACT_APP_API}/events/month-year/${baseMonth}/${baseYear}`;
        try {
            const res = await axios.get(url, authHeader);
            return res.data
                .filter(e => e.status === false)
                .map(e => {
                    const d = new Date(e.date);
                    d.setDate(d.getDate() - 1);
                    return {
                        id: e.id,
                        startDate: d.toISOString().split('T')[0],
                        endDate: null,
                        title: 'ไม่ว่าง',
                        color: '#D32F2F',
                    };
                });
        } catch (error) {
            console.error('Error fetching busy events:', error);
            return [];
        }
    };

    /** แปลง consultation data สำหรับแสดงเป็นตารางหรือรายละเอียด */
    mapConsultationData = (data, emojiMap) => {
        return data.map(item => ({
            id: item.id,
            symbol: emojiMap[item.symbol] || item.symbol || '❓',
            date: item.date || null,
            consult_method: item.consult_method || '-',
            consult_topic: Array.isArray(item.consult_topic)
                ? item.consult_topic.join(', ')
                : item.consult_topic || '-',
            details: item.consult_details || '-',
        }));
    };

    /** โหลด consultation + busy events ทั้งหมด ตาม state.month / state.year */
    fetchAllCalendarEvents = async () => {
        try {
            const emojiMap = {
                smile: '😊',
                cool: '😎',
                happy: '😁',
                curious: '🤔',
                whale: '🐳',
                flower: '🌸',
                heart: '❤️',
                dove: '🕊️',
                butterfly: '🦋',
                turtle: '🐢',
                star: '⭐',
                rainbow: '🌈',
            };

            const user = JSON.parse(localStorage.getItem('logged') || '{}')?.user?.user;
            const id = user?.id;
            if (!id) {
                throw new Error('ไม่พบข้อมูลผู้ใช้');
            }

            const { authHeader, month, year } = this.state;

            // ดึง consultation events
            const consultationEvents = await this.fetchConsultationEvents(id, authHeader, emojiMap);

            // ดึง busy events (3 เดือน) จาก API ใหม่
            const busyEvents = await this.fetchBusyEvents(authHeader, month, year);

            // รวม
            const calendarEvents = [...consultationEvents, ...busyEvents];

            // ดึงข้อมูล consultation data สำหรับตาราง/รายละเอียด
            const consRes = await axios.get(`${process.env.REACT_APP_API}/student-consultation/applicant/${id}`, authHeader);
            const consArr = Array.isArray(consRes.data) ? consRes.data : [consRes.data];
            const mappedCons = this.mapConsultationData(consArr, emojiMap);

            await this.promisedSetState({
                calendarEvents,
                consultationData: mappedCons,
                loading: false
            });
        } catch (err) {
            console.error('Error in fetchAllCalendarEvents:', err);
            window.location.href = '/login';
        }
    };

    onRenderContent = async ({ mode }) => {
        if (mode !== 'read') return;

        try {
            await this.promisedSetState({ loading: true });
            await this.fetchAllCalendarEvents();

            const { calendarEvents, consultationData, isMobile } = this.state;
            const user = JSON.parse(localStorage.getItem('logged') || '{}')?.user?.user;
            const id = user?.id;

            const renderCell = (date) => {
                const day = new Date(date.toISOString().split('T')[0]);
                const dayEvents = calendarEvents.filter(ev => {
                    const start = new Date(ev.startDate);
                    const end = ev.endDate ? new Date(ev.endDate) : start;
                    return day >= start && day <= end;
                });

                if (dayEvents.length === 0) {
                    return (
                        <div
                            onClick={() => {
                                const nxt = new Date(date);
                                nxt.setDate(nxt.getDate() + 1);
                                const fmt = nxt.toISOString().split('T')[0];
                                this.onModal({ mode: 'insert', id, date: fmt });
                            }}
                            style={{
                                width: '100%',
                                height: '100%',
                                cursor: 'pointer',
                                borderRadius: '8px',
                                transition: 'background 0.2s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#E9FCE9'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        />
                    );
                }

                const busyEvent = dayEvents.find(ev => ev.title === 'ไม่ว่าง');
                const emojiEvents = dayEvents.filter(ev => ev.title !== 'ไม่ว่าง');

                if (emojiEvents.length > 0) {
                    return (
                        <div
                            style={{
                                borderRadius: '25px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '1.6rem',
                                flexWrap: 'wrap',
                                gap: '6px',
                                flexDirection: isMobile ? 'column' : 'row'
                            }}
                        >
                            {emojiEvents.map((ev, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        marginTop: '0.2em',
                                        gap: isMobile ? '6px' : '4px'
                                    }}
                                >
                                    <span
                                        style={{
                                            backgroundColor: '#E3F2FD',
                                            borderRadius: '50%',
                                            width: '32px',
                                            height: '32px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '1.4rem',
                                            boxShadow: '0 0 2px rgba(0,0,0,0.1)',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <Whisper
                                            placement="top"
                                            trigger="click"
                                            speaker={
                                                <Tooltip style={{ padding: '8px', display: 'flex', gap: '8px' }}>
                                                    <Button size="sm" appearance="primary" color="yellow" onClick={() => this.onModal({ mode: 'update', id: ev.id })}>
                                                        แก้ไข
                                                    </Button>
                                                    <Button size="sm" appearance="primary" color="red" onClick={() => this.onConfirm({ mode: 'delete', id: ev.id })}>
                                                        ลบ
                                                    </Button>
                                                </Tooltip>
                                            }
                                        >
                                            <span>{ev.title}</span>
                                        </Whisper>
                                    </span>
                                </div>
                            ))}
                        </div>
                    );
                }

                if (busyEvent) {
                    return isMobile ? (
                        <i className="bi bi-x-circle-fill" style={{ color: '#D32F2F', fontSize: 20 }} />
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                backgroundColor: '#FFEBEE',
                                borderRadius: '25px',
                                padding: '8px 16px',
                                gap: '8px',
                                maxWidth: '100%',
                                boxSizing: 'border-box'
                            }}
                        >
                            <span
                                style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: busyEvent.color,
                                    display: 'inline-block'
                                }}
                            />
                            <span
                                style={{
                                    color: '#D32F2F',
                                    fontSize: 20,
                                    wordBreak: 'break-word'
                                }}
                            >
                                {busyEvent.title}
                            </span>
                        </div>
                    );
                }

                return null;
            };

            await this.promisedSetState({
                content: (
                    <>
                        <Row className="mt-3">
                            <Col>
                                <Breadcrumb size="lg">
                                    <Breadcrumb.Item>
                                        <Link to="/admin">
                                            <i className="bi bi-house-fill" />
                                        </Link>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>การให้คำปรึกษา</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12} className="mb-3">
                                <Panel
                                    header="ตารางการให้คำปรึกษา"
                                    className="shadow-sm"
                                    style={{
                                        backgroundColor: '#FFF',
                                        padding: '0.5em',
                                        height: '100%'
                                    }}
                                >
                                    <Button
                                        className="mt-3 mb-3"
                                        size="sm"
                                        startIcon={<i className="bi bi-plus-lg" />}
                                        color="green"
                                        appearance="primary"
                                        onClick={() => this.onModal({ mode: 'insert', id })}
                                    >
                                        เพิ่มนัดหมายปรึกษา
                                    </Button>

                                    <Row>
                                        <Col className="mb-3">
                                            <Calendar
                                                bordered
                                                renderCell={renderCell}
                                                onMonthChange={async (e) => {
                                                    const newMonth = e.getMonth() + 1;
                                                    const newYear = e.getFullYear();

                                                    await this.promisedSetState({ loading: true, month: newMonth, year: newYear });
                                                    try {
                                                        await this.onRenderContent({ mode })
                                                    } catch (err) {
                                                        console.error('Error fetching busy onMonthChange:', err);
                                                        window.location.href = '/login';
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </Panel>
                            </Col>
                        </Row>
                    </>
                ),
                loading: false
            });
        } catch (err) {
            console.error('Error in onRenderContent:', err);
            window.location.href = '/login';
        }
    };

    onModal = async ({ mode, id, sel, date }) => {
        let data;

        if (!sel) {
            if (mode === 'update') {
                const response = await axios.get(`${process.env.REACT_APP_API}/student-consultation/${id}`, this.state.authHeader);
                const item = response.data;

                data = {
                    date: item.date || '',
                    symbol: item.symbol || '',
                    full_name: item.full_name || '',
                    nickname: item.nickname || '',
                    gender: item.gender || '',
                    age: item.age || '',
                    year_level: item.year_level || '',
                    consult_topic: JSON.parse(item.consult_topic) || [],
                    next_field: item.next_field || '',
                    consult_details: item.consult_details || '',
                    consult_method: item.consult_method || '',
                    method_detail: item.method_detail || ''
                };
            } else {
                const response = await axios.get(`${process.env.REACT_APP_API}/applicants/${id}`, this.state.authHeader);
                const item = response.data[0];

                // ฟังก์ชันคำนวณอายุ
                function calculateAge(dobString) {
                    const dob = new Date(dobString);
                    const today = new Date();
                    let age = today.getFullYear() - dob.getFullYear();
                    const monthDiff = today.getMonth() - dob.getMonth();
                    const dayDiff = today.getDate() - dob.getDate();

                    // ถ้าวัน/เดือนเกิดยังไม่ถึงในปีนี้
                    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
                        age--;
                    }
                    return age;
                }

                // สร้าง data object
                data = {
                    date: '',
                    symbol: '',
                    full_name: `${item.first_name || ''} ${item.last_name || ''}`.trim(),
                    nickname: '',
                    gender: '',
                    age: item.date_of_birth ? calculateAge(item.date_of_birth) : '',
                    year_level: '',
                    consult_topic: [],
                    next_field: '',
                    consult_details: '',
                    consult_method: '',
                    method_detail: ''
                };
            }

            await this.promisedSetState(data);
        }

        date && await this.promisedSetState({ date });

        await this.promisedSetState({
            modal: (
                <Modal size={'md'}
                    backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title style={{ fontWeight: '700', fontSize: '1.4rem' }}>
                            ส่งคำขอการให้คำปรึกษา
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container fluid>

                            <Row>
                                <Col lg={4} className='mb-3'>
                                    <VStack>
                                        <label>วันที่นัดหมาย  <span className="text-danger">*</span></label>
                                        <div className='0pNF6' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.date}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async (e) => {
                                                    await this.promisedSetState({ date: e });
                                                    await this.onModal({ mode, id, sel: true });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ date: '' });
                                                    await this.onModal({ mode, id, sel: true });
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{
                                                    borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                                }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                            </Row>

                            <label className="mb-2">
                                กรุณาเลือกสัญลักษณ์ที่ต้องการใช้ในการขอคำปรึกษา <span className="text-danger">*</span>
                            </label>

                            <RadioGroup
                                className="mb-3 yT8kP"
                                defaultValue={this.state.symbol}
                                onChange={(val) => this.setState({ symbol: val })}
                            >
                                <Row
                                    style={{
                                        justifyContent: 'flex-start',
                                        gap: '0.5rem',  // ลดช่องว่างเหลือ 0.5rem
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    {[
                                        { val: 'smile', icon: '😊' },
                                        { val: 'cool', icon: '😎' },
                                        { val: 'happy', icon: '😁' },
                                        { val: 'curious', icon: '🤔' },
                                        { val: 'whale', icon: '🐳' },
                                        { val: 'flower', icon: '🌸' },
                                        { val: 'heart', icon: '❤️' },
                                        { val: 'dove', icon: '🕊️' },
                                        { val: 'butterfly', icon: '🦋' },
                                        { val: 'turtle', icon: '🐢' },
                                        { val: 'star', icon: '⭐' },
                                        { val: 'rainbow', icon: '🌈' },
                                    ].map(({ val, icon }) => (
                                        <Col
                                            xs="auto" md="auto" // ปรับให้กว้างพอดีกับเนื้อหาเลย
                                            style={{ margin: '0 2px' }} // ใกล้ชิดมากขึ้นด้วย margin น้อยๆ
                                            key={val}
                                        >
                                            <Radio value={val} style={{ fontSize: '1.5rem', padding: 0 }}>{icon}</Radio>
                                        </Col>
                                    ))}
                                </Row>
                            </RadioGroup>

                            <Row>
                                <Col md={6} className="mb-3">
                                    <VStack spacing={8}>
                                        <label>ชื่อ - นามสกุล <span className="text-danger">*</span></label>
                                        <Input
                                            className='bP3xZ'
                                            size="sm"
                                            defaultValue={this.state.full_name}
                                            onChange={e => this.setState({ full_name: e })}
                                        />
                                    </VStack>
                                </Col>
                                <Col md={3} className="mb-3">
                                    <VStack spacing={8}>
                                        <label>ชื่อเล่น <span className="text-danger">*</span></label>
                                        <Input
                                            className='qL7rK'
                                            size="sm"
                                            defaultValue={this.state.nickname}
                                            onChange={e => this.setState({ nickname: e })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={3} className="mb-3">
                                    <VStack spacing={8}>
                                        <label>เพศ <span className="text-danger">*</span></label>
                                        <SelectPicker
                                            className='dF1nM'
                                            size='lg'
                                            data={[
                                                { value: 'ชาย', label: 'ชาย' },
                                                { value: 'หญิง', label: 'หญิง' },
                                                { value: 'ไม่ระบุ', label: 'ไม่ระบุ' },
                                                { value: 'อื่นๆ', label: 'อื่นๆ' }
                                            ]}
                                            defaultValue={this.state.gender}
                                            searchable={false}
                                            style={{ width: 200 }}
                                            placeholder="เลือกรายการ"
                                            onChange={e => this.setState({ gender: e })}
                                            onClean={() => this.setState({ gender: '' })}
                                        />
                                    </VStack>
                                </Col>
                                <Col md={2} className="mb-3">
                                    <VStack spacing={8}>
                                        <label>อายุ <span className="text-danger">*</span></label>
                                        <InputNumber
                                            className='sW9eT'
                                            size='lg'
                                            min={0}
                                            defaultValue={this.state.age}
                                            onChange={e => this.setState({ age: e })}
                                        />
                                    </VStack>
                                </Col>
                                <Col md={3} className="mb-3">
                                    <VStack spacing={8}>
                                        <label>ระดับชั้นปี <span className="text-danger">*</span></label>
                                        <Input
                                            className='mG6vC'
                                            size="sm"
                                            defaultValue={this.state.year_level}
                                            onChange={e => this.setState({ year_level: e })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col className="mb-3">
                                    <VStack spacing={8}>
                                        <label className="fw-bold">
                                            หัวข้อที่ต้องการขอคำปรึกษา (เลือกได้มากกว่า 1 ข้อ) <span className="text-danger">*</span>
                                        </label>
                                        <CheckboxGroup
                                            className="vA4qL"
                                            defaultValue={this.state.consult_topic}
                                            onChange={e => this.setState({ consult_topic: e })}
                                        >
                                            <Checkbox value="stress">ความเครียดหรือวิตกกังวล</Checkbox>
                                            <Checkbox value="family">ความสัมพันธ์ในครอบครัว</Checkbox>
                                            <Checkbox value="gender">เพศและอัตลักษณ์</Checkbox>
                                            <Checkbox value="education">ปัญหาการเรียน</Checkbox>
                                            <Checkbox value="bullying">การถูกกลั่นแกล้ง</Checkbox>
                                            <Checkbox value="selfharm">ความคิดทำร้ายตัวเอง</Checkbox>
                                            <Checkbox value="other">อื่นๆ</Checkbox>
                                            <Input className='0N5BV'
                                                size="sm"
                                                placeholder="โปรดระบุ"
                                                defaultValue={this.state.next_field}
                                                onChange={e => this.setState({ next_field: e })}
                                            />
                                        </CheckboxGroup>
                                    </VStack>
                                </Col>
                            </Row>


                            <Row className="mt-3">
                                <Col className="mb-3">
                                    <VStack spacing={8}>
                                        <label className="fw-bold">กรุณาเล่ารายละเอียดหรือสิ่งที่คุณอยากปรึกษา <span className="text-danger">*</span><Text weight="thin" muted>(เขียนเท่าที่สบายใจ ไม่จำเป็นต้องระบุชื่อจริง)</Text></label>
                                        <Input
                                            className='nJ2bP'
                                            as="textarea"
                                            rows={4}
                                            defaultValue={this.state.consult_details}
                                            onChange={e => this.setState({ consult_details: e })} />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col className="mb-3">
                                    <VStack>
                                        <label className="fw-bold">
                                            ต้องการรับคำปรึกษาในรูปแบบใด <span className="text-danger">*</span>
                                        </label>
                                        <RadioGroup
                                            className="xE5tY"
                                            name="consult-method"
                                            defaultValue={this.state.consult_method}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ consult_method: e });
                                                this.onModal({ mode, id, sel: true });
                                            }}
                                        >
                                            <Radio value="chat">ผ่านข้อความ (แชท Line/Facebook)</Radio>
                                            {this.state.consult_method === 'chat' && (
                                                <Input className='qcZbG'
                                                    size="sm"
                                                    placeholder="ระบุช่องทางติดต่อ"
                                                    defaultValue={this.state.method_detail}
                                                    onChange={val => this.setState({ method_detail: val })}
                                                />
                                            )}

                                            <Radio value="phone">ผ่านโทรศัพท์</Radio>
                                            {this.state.consult_method === 'phone' && (
                                                <Input className='qcZbG'
                                                    size="sm"
                                                    placeholder="ระบุเบอร์โทรศัพท์"
                                                    defaultValue={this.state.method_detail}
                                                    onChange={val => this.setState({ method_detail: val })}
                                                />
                                            )}

                                            <Radio value="in_person">พบตัวต่อตัว</Radio>
                                            {this.state.consult_method === 'in_person' && (
                                                <Input className='qcZbG'
                                                    size="sm"
                                                    placeholder="ระบุสถานที่สะดวก"
                                                    defaultValue={this.state.method_detail}
                                                    onChange={val => this.setState({ method_detail: val })}
                                                />
                                            )}

                                            <Radio value="unsure">ไม่แน่ใจ / แล้วแต่ผู้ให้คำปรึกษาแนะนำ</Radio>
                                        </RadioGroup>
                                    </VStack>
                                </Col>
                            </Row>

                        </Container>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            size="md"
                            appearance="primary"
                            color={mode === 'insert' ? 'green' : 'yellow'}
                            startIcon={
                                mode === 'insert'
                                    ? <i className="bi bi-send-fill"></i>
                                    : <i className="bi bi-floppy-fill"></i>
                            }
                            onClick={() => this.onConfirm({ mode, id })}
                        >
                            {mode === 'insert' ? 'ส่งข้อมูล' : 'แก้ไข'}
                        </Button>

                        <Button
                            size="md"
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>
                    </Modal.Footer>

                </Modal>
            )
        });
    };

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ mode, id }) => {
        // --------------------- DELETE MODE ---------------------
        if (mode === 'delete') {
            this.setState({ loading: true });

            Swal.fire({
                title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const response = await axios.delete(
                            `${process.env.REACT_APP_API}/student-consultation/${id}`,
                            this.state.authHeader
                        );

                        const data = response.data;

                        if (data.message === 'successfully') {
                            Swal.fire({
                                title: "ลบข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        } else {
                            Swal.fire({
                                title: "เกิดข้อผิดพลาดในการลบ",
                                text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                icon: "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    } catch (error) {
                        if (error.response?.status === 401) {
                            window.location.href = '/login';
                        } else {
                            // จัดการ error อื่น ๆ ตามปกติ
                            Swal.fire({
                                title: 'เกิดข้อผิดพลาด',
                                text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                icon: 'error',
                                confirmButtonText: 'ตกลง'
                            });
                        }
                    }
                }
            });

            this.setState({ loading: false });
            return;
        }

        const validateCounsel = async () => {
            const validationPromises = [
                this.Validate(this.state.date, '0pNF6', ''),
                this.Validate(this.state.symbol, 'yT8kP', ''),
                this.Validate(this.state.full_name, 'bP3xZ', ''),
                this.Validate(this.state.nickname, 'qL7rK', ''),
                this.Validate(this.state.gender, 'dF1nM', ''),
                this.Validate(this.state.age, 'sW9eT', ''),
                this.Validate(this.state.year_level, 'mG6vC', ''),
                this.Validate(this.state.consult_topic, 'vA4qL', ''),
                ...(this.state.consult_topic.includes('other')
                    ? [this.Validate(this.state.next_field, '0N5BV', '')]
                    : []),
                this.Validate(this.state.consult_details, 'nJ2bP', ''),
                this.Validate(this.state.consult_method, 'xE5tY', ''),
                ...(['chat', 'phone', 'in_person'].includes(this.state.consult_method)
                    ? [this.Validate(this.state.method_detail, 'qcZbG', '')]
                    : []
                ),
            ];

            const results = await Promise.all(validationPromises);
            return results.every(result => result === true);
        };

        if (await validateCounsel()) {
            try {
                this.setState({ loading: true });

                if (mode === 'insert') {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API}/student-consultation`,
                        {
                            applicants_id: id,
                            date: this.state.date,
                            symbol: this.state.symbol,
                            full_name: this.state.full_name,
                            nickname: this.state.nickname,
                            gender: this.state.gender,
                            age: this.state.age,
                            year_level: this.state.year_level,
                            consult_topic: this.state.consult_topic,
                            next_field: this.state.consult_topic.includes('other') ? this.state.next_field : '',
                            consult_details: this.state.consult_details,
                            consult_method: this.state.consult_method,
                            method_detail: ['chat', 'phone', 'in_person'].includes(this.state.consult_method)
                                ? this.state.method_detail
                                : ''
                        },
                        this.state.authHeader
                    );

                    if (response.data.message === 'successfully') {

                        // emoji map
                        const emojiMap = {
                            smile: '😊',
                            cool: '😎',
                            happy: '😁',
                            curious: '🤔',
                            whale: '🐳',
                            flower: '🌸',
                            heart: '❤️',
                            dove: '🕊️',
                            butterfly: '🦋',
                            turtle: '🐢',
                            star: '⭐',
                            rainbow: '🌈',
                        };

                        // ฟังก์ชันแปลง consult_method เป็นข้อความ
                        function formatConsultMethod(method) {
                            switch (method) {
                                case 'chat':
                                    return 'ผ่านข้อความ (แชท Line/Facebook)';
                                case 'phone':
                                    return 'ผ่านโทรศัพท์';
                                case 'in_person':
                                    return 'พบตัวต่อตัว';
                                case 'unsure':
                                    return 'ไม่แน่ใจ / แล้วแต่ผู้ให้คำปรึกษาแนะนำ';
                                default:
                                    return '-';
                            }
                        }

                        // ฟังก์ชันแปลงวันเป็นรูปแบบไทย "28 พ.ย. 2568"
                        function formatThaiDate(dateString) {
                            const months = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
                            const date = new Date(dateString);
                            const day = date.getDate();
                            const month = months[date.getMonth()];
                            const year = date.getFullYear() + 543; // ปีพุทธศักราช
                            return `${day} ${month} ${year}`;
                        }

                        // สร้างข้อความแจ้งเตือนแบบสั้น พร้อม emoji
                        const emoji = emojiMap[this.state.symbol] || ''; // เอา emoji ตาม symbol
                        const messageText = `มีผู้ขอคำปรึกษาใหม่! ${emoji}\n` +
                            `📅 วันที่ให้คำปรึกษา: ${formatThaiDate(this.state.date)}\n` +
                            `📝 ช่องทางรับคำปรึกษา: ${formatConsultMethod(this.state.consult_method)} [${this.state.method_detail}]\n` +
                            `👉 ตรวจสอบข้อมูลเพิ่มเติม: https://applyscholarship.maefahluang.org/admin/counseling`;

                        // ส่งข้อความ
                        const messageResponse = await axios.post(`${process.env.REACT_APP_API}/messages`, {
                            message: messageText
                        });

                        if (messageResponse.data.message === 'successfully') {

                            Swal.fire({
                                title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.promisedSetState({
                                    date: '',
                                    symbol: '',
                                    full_name: '',
                                    nickname: '',
                                    gender: '',
                                    age: '',
                                    year_level: '',
                                    consult_topic: [],
                                    next_field: '',
                                    consult_details: '',
                                    consult_method: '',
                                    method_detail: ''
                                });

                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        }
                    }
                } else if (mode === 'update') {
                    const response = await axios.patch(
                        `${process.env.REACT_APP_API}/student-consultation`,
                        {
                            id: id, // ต้องมี id ของรายการที่จะแก้ไข
                            date: this.state.date,
                            symbol: this.state.symbol,
                            full_name: this.state.full_name,
                            nickname: this.state.nickname,
                            gender: this.state.gender,
                            age: this.state.age,
                            year_level: this.state.year_level,
                            consult_topic: this.state.consult_topic,
                            next_field: this.state.consult_topic.includes('other') ? this.state.next_field : '',
                            consult_details: this.state.consult_details,
                            consult_method: this.state.consult_method,
                            method_detail: ['chat', 'phone', 'in_person'].includes(this.state.consult_method)
                                ? this.state.method_detail
                                : ''
                        },
                        this.state.authHeader
                    );

                    if (response.data.message === 'successfully') {
                        Swal.fire({
                            title: "แก้ไขข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                id: '',
                                date: '',
                                symbol: '',
                                full_name: '',
                                nickname: '',
                                gender: '',
                                age: '',
                                year_level: '',
                                consult_topic: [],
                                next_field: '',
                                consult_details: '',
                                consult_method: '',
                                method_detail: ''
                            });

                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }
                }

                // หลังบันทึกเสร็จ (insert/update)
                // await this.onSuccess({ mode: 'read' });

            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = '/login';
                } else {
                    // จัดการ error อื่น ๆ ตามปกติ
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                }
            } finally {
                this.setState({ loading: false });
            }
        }
    };

    render() {
        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}